// extracted by mini-css-extract-plugin
module.exports = {"code":"SafeImage_code__9HAP6"};